import React from 'react';
import Box from 'relements/build/esm/ui/box';

import Skeleton from '@src/components/Skeleton';
import { Container } from './styledComponents';

function SetupLoading() {
  return (
    <Container>
      <Box padding="zero" flexDirection="column">
        <Box padding="zero" alignItems="center">
          <Skeleton animation circle size="50px" />
          <Skeleton height="25px" width="150px" animation marginLeft="10px" />
        </Box>
        {[...Array(6)].map(() => (
          <>
            <Skeleton height="15px" width="100px" marginTop="26px" animation />
            <Skeleton height="42px" width="500px" marginTop="8px" animation />
          </>
        ))}
      </Box>
    </Container>
  );
}

export default React.memo(SetupLoading);
